module.exports = __webpack_public_path__ + "img/IMG_3621.d870a910.jpg";